import { Box, SxProps, Theme, Typography } from '@mui/material';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import {
	emptyFavoriteProductFrameSX,
	emptyFavoriteProductIconSX,
	emptyFavoriteProductMessageSX,
	emptyFavoriteProductTitleSX,
} from '@/components/blocks/EmptyFavoriteProduct/styles';
import { combineSX } from '@/utils/combineSX';

interface Props {
	type: 'favorites' | 'saved';
	variant?: 'primary' | 'secondary';
	framesx?: SxProps<Theme>;
}

export const EmptyFavoriteProduct: React.FC<Props> = ({ type, variant = 'primary', framesx }) => (
	<Box
		sx={combineSX([
			emptyFavoriteProductFrameSX(variant),
			...(Array.isArray(framesx) ? framesx : [framesx]),
		])}
	>
		{type === 'saved' ? (
			<LocalMallIcon sx={emptyFavoriteProductIconSX} />
		) : (
			<FavoriteBorderIcon sx={emptyFavoriteProductIconSX} />
		)}
		<Typography sx={emptyFavoriteProductTitleSX}>{'¡Ups! Parece que está vacío'}</Typography>
		<Typography sx={emptyFavoriteProductMessageSX}>
			{type === 'favorites'
				? 'Aún no tienes productos agregados a favoritos. Comienza agregando algunos artículos.'
				: 'Aún no tienes productos guardados para comprar después. Comienza agregando algunos artículos.'}
		</Typography>
	</Box>
);
